var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99973 5.00155L7.85668 7.85832M4.99973 5.00155L6.33297 3.66839V3.47794L5.2359 3.02085C4.44739 2.69227 3.70883 2.2548 3.04177 1.72121L2.14278 1.00207H1.95232L1 1.95432V2.14478L1.71919 3.04371C2.25281 3.71073 2.69031 4.44925 3.01891 5.23771L3.47602 6.33471H3.66649L4.99973 5.00155ZM10.3205 12.8101C11.5157 14.1663 12.6633 15.5638 13.761 17H13.9515L16.9989 13.9528V13.7623C16.9989 13.7623 15.1171 12.3515 12.8087 10.322M13.1896 8.62013C13.8222 8.62031 14.4449 8.46295 15.0015 8.16227C15.558 7.86158 16.0309 7.42703 16.3775 6.89784C16.7241 6.36866 16.9334 5.7615 16.9865 5.13118C17.0397 4.50087 16.935 3.86723 16.682 3.28749H16.2371L13.9515 5.5729H12.4278V4.04929L14.7134 1.76387V1.31898C14.0305 1.02045 13.2751 0.928779 12.5406 1.05531C11.8062 1.18183 11.125 1.521 10.5814 2.03081C10.0379 2.54062 9.65579 3.19867 9.48252 3.92346C9.30926 4.64825 9.35241 5.40795 9.60665 6.10845L8.2376 7.47742C4.80927 10.9055 1 13.7623 1 13.7623V13.9528L4.04741 17H4.23788C4.23788 17 7.09482 13.191 10.5232 9.76284L11.8922 8.39387C12.3083 8.54405 12.7473 8.62061 13.1896 8.62013Z",
    stroke: "white",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIcon);
export default __webpack_public_path__ + "static/media/toolsIcon.386c9e47396cf8788686ed68ec9bfda9.svg";
export { ForwardRef as ReactComponent };